import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Spin } from 'antd';
import { makeStyles } from '@material-ui/styles';

import Api from 'config/api';
import { formatNumberAsCurrency } from 'utils/helpers';

import 'antd/dist/antd.css';

const TotalRevenueInState = ({ isLoading }) => {
  const [revenue, setRevenue] = useState([]);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    getRevenue();
  }, []);

  const getRevenue = async () => {
    setLoading(true);
    try {
      const { data } = await Api.get('website/get-TotalRevenue');
      setRevenue(data?.data);
    } catch (error) {}
    setLoading(false);
  };

  const yearUnderConsideration = revenue[0]?.year || 0;

  const renderContributionOfTotalAvailableRevenue = () => {
    return (
      <div className={classes.totalAvailableRevenue}>
        <span>
          % Contribution of Total Revenue Available {yearUnderConsideration}
        </span>
        <Row align='end' className='sub-title-container'>
          <Col span={12}>FAAC</Col>
          <Col span={12}>IGR</Col>
        </Row>
      </div>
    );
  };

  const renderColumns = [
    {
      title: 'State',
      dataIndex: 'state',
      fixed: 'left',
      width: 100,
      render: (text) => <span className={classes.boldText}>{text}</span>,
    },
    {
      title: `FAAC ${yearUnderConsideration} (₦)`,
      dataIndex: 'faac',
      render: (text) => <span>{formatNumberAsCurrency(text, 2)}</span>,
    },
    {
      title: `IGR ${yearUnderConsideration} (₦)`,
      dataIndex: 'igr',
      render: (text) => (
        <span className={classes.errorText}>
          {formatNumberAsCurrency(text, 2)}
        </span>
      ),
    },
    {
      title: `Total Revenue Available ${yearUnderConsideration} (₦)`,
      dataIndex: 'totaRevenuePresentYear', //totaRevenuePresentYear
      render: (text) => <span>{formatNumberAsCurrency(text, 2)}</span>,
    },
    {
      title: `% Share of Total FAAC ${yearUnderConsideration}`,
      dataIndex: 'percentageTotalShareFAAC',
      render: (text) => <span>{text}</span>,
    },
    {
      title: `% Share of Total State IGR ${yearUnderConsideration}`,
      dataIndex: 'percentageTotalShareIGP',
    },
    {
      title: renderContributionOfTotalAvailableRevenue(),
      dataIndex: 'percentageTotalRevenueFAAC',
      colSpan: 2,
    },
    {
      title: `% Contribution of Total Revenue Available ${yearUnderConsideration}`,
      dataIndex: 'percentageTotalRevenueIGP',
      colSpan: 0,
    },
    {
      title: `Total Revenue Available ${yearUnderConsideration}(₦)`,
      dataIndex: 'totaRevenuePreviousYear',
    },
    {
      title: `${yearUnderConsideration} ON ${yearUnderConsideration - 1} Year on Year Growth %`,
      dataIndex: 'yearGrowth',
    },
  ];

  return (
    <>
      <div className={classes.header}>
        Total Revenue Available To State In {yearUnderConsideration}
      </div>
      <Spin spinning={loading}>
        <Table
          columns={renderColumns}
          scroll={{ y: 300, x: 2000 }}
          dataSource={revenue}
          loading={isLoading}
          rowKey={(record) => record.id}
          pagination={false}
          className={classes.table}
        />
      </Spin>
    </>
  );
};

const useStyles = makeStyles({
  header: {
    background: '#1E8449',
    padding: `10px 30px`,
    color: '#fff',
    fontWeight: 700,
  },
  table: {
    '& .ant-table-thead > tr > th:nth-child(7)': {
      background: '#BDBDBD',
    },
    '& .ant-table-tbody > tr > td:nth-child(6)': {
      background: '#FFF5D7',
    },
    '& .ant-table-tbody > tr > td:nth-child(7), & .ant-table-tbody > tr > td:nth-child(8)': {
      background: '#BDBDBD',
    },
    '& .ant-table-tbody > tr > td:nth-child(9)': {
      background: '#FFE7E3',
    },
  },
  errorText: {
    color: '#FF0000',
  },
  boldText: {
    fontWeight: 700,
  },
  totalAvailableRevenue: {
    textAlign: 'left',
    '& .sub-title-container': {
      marginTop: 10,
      '&>div:nth-child(2)': {
        paddingLeft: 15,
      },
    },
  },
});

export default React.memo(TotalRevenueInState);
